import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { RegistrationConnectConsultService } from '@gipi-registration/connect-consult/services/connect-consult.service';
import { GIPIAbstractComponent, GIPIBaseService, ObjectUtil, StringUtil } from '@gipisistemas/ng-core';

@Component({
    templateUrl: './connect-detail-dialog.component.html',
})
export class ConnectDetailDialogComponent extends GIPIAbstractComponent implements OnInit {

    @ViewChild('reportIframe', { static: true }) reportIframe: ElementRef<HTMLIFrameElement>;

    constructor(
        protected service: RegistrationConnectConsultService,
        protected baseService: GIPIBaseService,
        protected activatedRoute: ActivatedRoute,
        public dialogRef: MatDialogRef<ConnectDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string = '',
    ) {
        super(baseService, activatedRoute);
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {
        super.ngOnInit();
        this.detailConnectFull();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public async detailConnectFull(): Promise<void> {
        try {
            if (StringUtil.isEmpty(this.data)) {
                return;
            }
            if (!ObjectUtil.isNull(this.data)) {
                const blob = new Blob([this.data], { type: 'text/html' });
                const url = URL.createObjectURL(blob);
                this.reportIframe.nativeElement.src = url;
                this.reportIframe.nativeElement.onload = () => URL.revokeObjectURL(url);
                this.loading = false;
            }
        } catch (e) {
            this.loading = false;
            this.addErrorMessage(e);
        }
    }

    /**
     * @template RELOAD_TABLE Dá reload na grid atualizando os registros
     * @template REMARK_SELECTED Volta a tela anterior e seleciona os registros na grid
     * @template NONE Não acontece nada, só volta para tela anterior
     */
    public close(operation: 'RELOAD_TABLE' | 'REMARK_SELECTED' | 'NONE'): void {
        this.dialogRef.close(operation);
    }

}
